import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Radio, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import moment from "moment-timezone";
import numeral from "numeral";
import { maskDate } from "../utils/Masker";

const { Item: ItemForm } = Form;
const { Column } = Table;
const ButtonGroup = Button.Group;

export default class PedidoItemEntregaForm extends Component {
  state = {
    editando: false,
    formEntregaDisabled: false,
    produtoEntregaSelecionado: [],
    listaEntregas: [],
    qtde_Total: 0,

    registro: {
      vie_item: 0,
      vie_item_seq: 0,
      vie_seq: 1,
      vie_data: moment().format('DD/MM/YYYY'),
      vie_qtde: 0,
      vie_embalagem: '',
      vie_cond_pagto: '',
      vie_situacao: 0,
      se_abrev: 'PED',
      se_descricao: 'PEDIDO',

      qtde_entrega: 0,
      qtde_restante: 0,
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.produtoEntregaSelecionado !== propsAnterior.produtoEntregaSelecionado) {

      // console.log('PedidoItemEntregaForm - componentDidUpdate: ', this.props.produtoEntregaSelecionado)

      this.state.registro.vie_qtde = this.props.produtoEntregaSelecionado.vi_qtde ? this.props.produtoEntregaSelecionado.vi_qtde : 0;
      this.state.editando = this.props.produtoEntregaSelecionado.editando;

      let listaRegistros = [];
      const lista = this.props.listaEntregas ? this.props.listaEntregas : [];
      for (var x in lista) {
        if (lista[x].vie_item === this.props.produtoEntregaSelecionado.prod_idf) {
          listaRegistros.push({
            vie_item: lista[x].vie_item,
            vie_item_seq: lista[x].vie_item_seq,
            vie_seq: lista[x].vie_seq,
            vie_data: lista[x].vie_data,
            vie_qtde: lista[x].vie_qtde,
            vie_embalagem: lista[x].vie_embalagem,
            vie_cond_pagto: lista[x].vie_cond_pagto,
            vie_situacao: lista[x].vie_situacao,
            se_abrev: lista[x].se_abrev,
            se_descricao: lista[x].se_descricao,
          });
        }
      };


      this.setState({
        produtoEntregaSelecionado: this.props.produtoEntregaSelecionado ? this.props.produtoEntregaSelecionado : [],
        listaEntregas: listaRegistros,
        qtde_Total: this.props.produtoEntregaSelecionado.vi_qtde ? this.props.produtoEntregaSelecionado.vi_qtde : 0
      }, () => {
        this.calculoQtde(listaRegistros)
      });
    }
  }

  componentDidMount() {

  }





  onOK = () => {
    let listaRegistros = [];
    const listaGeral = this.props.listaEntregas;
    const listaAtual = this.state.listaEntregas;

    for (var x in listaGeral) {
      if (listaGeral[x].vie_item !== this.props.produtoEntregaSelecionado.prod_idf) {
        listaRegistros.push({
          vie_item: listaGeral[x].vie_item,
          vie_item_seq: listaGeral[x].vie_item_seq,
          vie_seq: listaGeral[x].vie_seq,
          vie_data: listaGeral[x].vie_data,
          vie_qtde: listaGeral[x].vie_qtde,
          vie_embalagem: listaGeral[x].vie_embalagem,
          vie_cond_pagto: listaGeral[x].vie_cond_pagto,
          vie_situacao: listaGeral[x].vie_situacao,
          se_abrev: listaGeral[x].se_abrev,
          se_descricao: listaGeral[x].se_descricao,
        });
      }
    }

    for (var x in listaAtual) {
      if (listaAtual[x].vie_item === this.props.produtoEntregaSelecionado.prod_idf) {
        listaRegistros.push({
          vie_item: listaAtual[x].vie_item,
          vie_item_seq: listaAtual[x].vie_item_seq,
          vie_seq: listaAtual[x].vie_seq,
          vie_data: listaAtual[x].vie_data,
          vie_qtde: listaAtual[x].vie_qtde,
          vie_embalagem: listaAtual[x].vie_embalagem,
          vie_cond_pagto: listaAtual[x].vie_cond_pagto,
          vie_situacao: listaAtual[x].vie_situacao,
          se_abrev: listaAtual[x].se_abrev,
          se_descricao: listaAtual[x].se_descricao,
        });
      }
    }

    this.props.onSalvarEntregasClick(listaRegistros);
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onDataChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['vie_data'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ vie_data: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onChangeQtde = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };


  calculoQtde = (listaEntregas) => {
    const { registro } = this.state;
    let entrega = 0;
    for (var x in listaEntregas) {
      entrega = entrega + parseFloat(listaEntregas[x].vie_qtde);
    };
    registro.qtde_entrega = parseFloat(entrega);
    registro.qtde_restante = this.state.qtde_Total - entrega;
    registro.vie_qtde = this.state.qtde_Total - entrega;

    // console.log('calculoQtde: ', registro.qtde_entrega)
    // console.log('calculoQtde: ', registro.qtde_restante)
    // console.log('calculoQtde: ', registro.vie_qtde)


    this.setState({
      registro
    });
  }





  onAdicionarClick = reg => {
    let registro = {
      vie_seq: this.state.listaEntregas.length + 1,
      vie_data: moment().format('DD/MM/YYYY'),
      vie_qtde: this.state.qtde_restante,
      vie_embalagem: '',
      vie_cond_pagto: '',
      vie_situacao: 0,
      se_abrev: 'PED',
      se_descricao: 'PEDIDO',
    }
    this.setState({
      registro,
      formEntregaDisabled: false,
    });
  }

  onGravarClick = (value) => {
    const { registro } = this.state;

    const dataAtual = moment().format('YYYY-MM-DD');
    const dataPagto = moment(registro.vie_data, 'DD/MM/YYYY').format('YYYY-MM-DD');
    if (dataPagto < dataAtual) {
      Modal.warning({ title: 'Aviso!', content: 'Data de Entrega menor que data atual', });
      return;
    }

    if (!registro.vie_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a quantidade', });
      return;
    }

    if ((registro.vie_qtde) && (parseFloat(registro.vie_qtde) < 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Quantidade menor que zero', });
      return;
    }

    if ((this.state.vie_qtde) && (parseFloat(this.state.vie_qtde) > parseFloat(this.state.qtde_restante))) {
      Modal.warning({ title: 'Aviso!', content: 'Quantidade maior do que o retante', });
      return;
    }


    const iInd = this.state.listaEntregas ? this.state.listaEntregas.findIndex(reg => String(reg.vie_seq) === String(registro.vie_seq)) : -1;

    if (iInd >= 0) {

      this.state.listaEntregas[iInd].vie_data = moment(registro.vie_data, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.state.listaEntregas[iInd].vie_qtde = registro.vie_qtde;
      this.state.listaEntregas[iInd].vie_embalagem = registro.vie_embalagem;
      this.state.listaEntregas[iInd].vie_cond_pagto = registro.vie_cond_pagto;

    } else {

      this.state.listaEntregas.push({
        vie_item: this.props.produtoEntregaSelecionado.prod_idf,
        vie_item_seq: this.props.produtoEntregaSelecionado.vi_seq,
        vie_seq: registro.vie_seq,
        vie_data: moment(registro.vie_data, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        vie_qtde: registro.vie_qtde,
        vie_embalagem: registro.vie_embalagem,
        vie_cond_pagto: registro.vie_cond_pagto,
        vie_situacao: registro.vie_situacao,
        se_abrev: registro.se_abrev,
        se_descricao: registro.se_descricao,
      });

    }


    this.setState({
      formEntregaDisabled: false,
      registro: {
        vie_seq: this.state.listaEntregas.length + 1,
        vie_data: moment().format('DD/MM/YYYY'),
        vie_qtde: 0,
        vie_embalagem: '',
        vie_cond_pagto: '',
        vie_situacao: 0,
        se_abrev: 'PED',
        se_descricao: 'PEDIDO',
      }
    }, () => {
      this.calculoQtde(this.state.listaEntregas)
    });

  };

  onEditarClick = registro => {
    // console.log('onEditarClick: ', registro);

    let reg = {
      vie_seq: registro.vie_seq,
      vie_data: moment(registro.vie_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
      vie_qtde: registro.vie_qtde,
      vie_embalagem: registro.vie_embalagem,
      vie_cond_pagto: registro.vie_cond_pagto,
      vie_situacao: registro.vie_situacao,
      se_abrev: registro.se_abrev,
      se_descricao: registro.se_descricao,
    }
    this.setState({
      registro: reg,
      formEntregaDisabled: false,
    });

  };

  onExcluirClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir esta Entrega?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaEntregas = [...this.state.listaEntregas];
        const index = listaEntregas.findIndex(registro => registro.vie_seq === reg.vie_seq);
        listaEntregas.splice(index, 1);
        this.setState({
          listaEntregas,
        },
          this.calculoQtde(listaEntregas)
        );
      }
    })
  }

  onCancelarClick = (value) => {
    this.setState({
      formEntregaDisabled: true,
      registro: {
        vie_seq: this.state.listaEntregas.length + 1,
        vie_data: moment().format('DD/MM/YYYY'),
        vie_qtde: 0,
        vie_embalagem: '',
        vie_cond_pagto: '',
        vie_situacao: 0,
        se_abrev: 'PED',
        se_descricao: 'PEDIDO',
      }
    });
  };







  renderValor = (valor) => {
    return (
      <span> {numeral(parseFloat(valor)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderAcoesParcelas = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir" placement="top">
          <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };



  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalEntregaClick, visivel } = this.props;
    const { editando, listaEntregas, formEntregaDisabled, qtde_Total } = this.state;
    const { vie_seq, vie_data, vie_qtde, vie_embalagem, vie_cond_pagto, qtde_entrega, qtde_restante } = this.state.registro;

    // console.log('PedidoItemEntregaForm.this.state: ', this.state);

    return (
      <Modal
        title="Entregas"
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalEntregaClick}
        footer={null}
        width={"60%"}
        style={{ top: 40 }}
      >
        <div>

          {editando ? (
            <div>
              <Row>
                <Col xs={24} sm={8} className="camposEspacoDireita">
                  <span>Item</span>
                  <InputForm
                    id="vie_seq"
                    ref="vie_seq"
                    onChange={this.onChange}
                    value={vie_seq}
                    disabled={true}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: 4 }} className="camposEspacoDireita">
                  <span>Data Entrega</span>
                  <DatePicker
                    onChange={this.onDataChange}
                    format="DD/MM/YYYY"
                    showToday={true}
                    value={moment(vie_data, "DD/MM/YYYY", true)}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: 2 }}>
                  <span>Quantidade</span>
                  <InputForm
                    type="number"
                    id="vie_qtde"
                    ref="vie_qtde"
                    value={vie_qtde}
                    onChange={this.onChangeQtde}
                  />
                </Col>
                <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 10 }}>
                  <span>Embalagem</span>
                  <InputForm
                    id="vie_embalagem"
                    ref="vie_embalagem"
                    value={vie_embalagem}
                    maxLength={45}
                    onChange={this.onChange}
                    validator={value => Boolean(value)}
                  />
                </Col>
                <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                  <span>Cond. Pagto</span>
                  <InputForm
                    id="vie_cond_pagto"
                    ref="vie_cond_pagto"
                    value={vie_cond_pagto}
                    maxLength={45}
                    onChange={this.onChange}
                    validator={value => Boolean(value)}
                  />
                </Col>
              </Row>


              <Row style={{ marginBottom: 15, marginTop: -30 }}>
                <Col xs={24}>
                  <Button
                    className="botoesModalFormEditar"
                    onClick={this.onAdicionarClick}
                    style={{ float: "left", marginRight: 10, marginLeft: 15, width: 100 }}
                  >
                    Novo
                  </Button>
                  {formEntregaDisabled ? null : (
                    <div>
                      <Button
                        className="botoesModalFormEditar"
                        htmlType="button"
                        onClick={this.onGravarClick}
                        style={{ float: "right", marginRight: 10, marginLeft: 15, width: 150 }}
                      >
                        Salvar Entrega
                      </Button>

                      <Tooltip title="Voltar para Lista de Parcelas">
                        <Button
                          htmlType="button"
                          onClick={this.onCancelarClick}
                          style={{ float: "right", marginRight: 10, marginLeft: 15, width: 100 }}
                        >
                          Voltar
                        </Button>
                      </Tooltip>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          ) : null}


          <Row style={{}}>
            <div className="div-subTitulo" style={{ height: 30 }}>
              <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17, paddingTop: -5 }}>
                Lista das Entregas
              </span>
            </div>

            <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
              <Col xs={24}>
                <Col xs={24} sm={8}>
                  <span style={{ fontWeight: "bold" }}>Qtde Total: </span>
                  <span>{this.renderValor(qtde_Total)}</span>
                </Col>
                <Col xs={24} sm={8}>
                  <span style={{ fontWeight: "bold" }}>Qtde Entregas: </span>
                  <span>{this.renderValor(qtde_entrega)}</span>
                </Col>
                <Col xs={24} sm={8}>
                  <span style={{ color: "red", fontWeight: "bold" }}>Qtde Restante: </span>
                  <span>{this.renderValor(qtde_restante)}</span>
                </Col>
              </Col>
            </Row>

            <Table
              dataSource={listaEntregas}
              pagination={false}
              rowKey={(listaEntregas => listaEntregas.vie_seq)}
            >
              <Column
                key="vie_seq"
                dataIndex="vie_seq"
                title="Item"
                width={20}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="vie_data"
                dataIndex="vie_data"
                title="Data Entrega"
                width={50}
                align="center"
                className="listaCadastro"
                render={this.renderData}
              />
              <Column
                key="vie_qtde"
                dataIndex="vie_qtde"
                title="Qtde"
                render={this.renderValor}
                width={40}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="se_abrev"
                dataIndex="se_abrev"
                title="Status"
                width={30}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="vie_embalagem"
                dataIndex="vie_embalagem"
                title="Embalagem"
                width={30}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="vie_cond_pagto"
                dataIndex="vie_cond_pagto"
                title="Cond Pagto"
                width={30}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="se_descricao"
                dataIndex="se_descricao"
                title="Status"
                width={30}
                align="left"
                className="listaCadastro"
              />
              {editando ? (
                <Column
                  key="acoes"
                  title=""
                  render={this.renderAcoesParcelas}
                  width={40}
                  align="center"
                  className="listaCadastro"
                />
              ) : null}
            </Table>
          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                {editando ? (
                  <Button
                                        htmlType="button"
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar
                  </Button>
                ) : null}
                <Button
                  htmlType="button"
                  onClick={onFecharModalEntregaClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PedidoItemEntregaForm.js